import { Link, useNavigate } from '@tanstack/react-router'
import { BookOpen, Flame, LogOut, UserRound, Wallet } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import { LEGACY_PRODUCT_NAME } from '../../lib/product'
import { Avatar, DropdownMenu } from '../ui'

export function Header() {
  const { user, features, signOut } = useAuth()
  const navigate = useNavigate()

  return (
    <header className="border-b border-border bg-surface/80 backdrop-blur">
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/steam/groups" className="inline-flex items-center gap-2">
          <Flame className="h-5 w-5 text-ember-400" strokeWidth={1.75} aria-hidden="true" />
          <span className="font-display text-lg tracking-tight text-text-strong">{LEGACY_PRODUCT_NAME}</span>
        </Link>
        <div className="flex items-center gap-3">
          {user && (
            <Link
              to="/steam/library"
              className="hidden rounded-control px-1.5 py-1 text-sm text-text-muted transition hover:text-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ember-400 focus-visible:ring-offset-2 focus-visible:ring-offset-canvas sm:block"
            >
              Library
            </Link>
          )}
          {user && features.group_wallet && (
            <Link
              to="/steam/wallet"
              className="hidden rounded-control px-1.5 py-1 text-sm text-text-muted transition hover:text-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ember-400 focus-visible:ring-offset-2 focus-visible:ring-offset-canvas sm:block"
            >
              Wallet
            </Link>
          )}
          {user && (
            <DropdownMenu
              align="right"
              items={[
                {
                  label: 'Profile',
                  icon: <UserRound className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" />,
                  onSelect: () => void navigate({ to: '/steam/profile' }),
                },
                {
                  label: 'Library',
                  icon: <BookOpen className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" />,
                  onSelect: () => void navigate({ to: '/steam/library' }),
                },
                ...(features.group_wallet
                  ? [
                      {
                        label: 'Wallet',
                        icon: <Wallet className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" />,
                        onSelect: () => void navigate({ to: '/steam/wallet' }),
                      },
                    ]
                  : []),
                {
                  label: 'Sign out',
                  icon: <LogOut className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" />,
                  tone: 'danger',
                  onSelect: () => void signOut(),
                },
              ]}
              trigger={({ ref, toggleProps }) => (
                <button
                  ref={ref}
                  {...toggleProps}
                  aria-label="Account menu"
                  className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ember-400 focus-visible:ring-offset-2 focus-visible:ring-offset-canvas"
                >
                  <Avatar name={user.display_name} src={user.avatar_url} size="sm" />
                </button>
              )}
            />
          )}
        </div>
      </div>
    </header>
  )
}
